import React from 'react';
import { ResponseContainer } from './DisplayContainer';
import styled from 'styled-components';
import { isJson } from 'lib/utils/WYSIWYGEditorHelper';
import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw } from 'draft-js';
import { useTranslation } from 'react-i18next';

const MeidaDisplay = (props) => {
  const { t } = useTranslation();
  const { question } = props;

  return (
    <>
      {
        isJson(question.note) ? (
          <div
            style={{ marginBottom: 10 }}
            dangerouslySetInnerHTML={{
              __html: stateToHTML(
                convertFromRaw(JSON.parse(question.note))
              ),
            }}
          />
        ) : (
          <div style={{ marginBottom: 10 }}>
            {question.note}
          </div>
        )
      }
      {question.media && (
        <iframe
          style={{
            border: 'none',
            width: "100%",
            maxWidth: "600px",
            aspectRatio: "16 / 9"
          }}
          src={question.media}
          title={t('YouTube video player')}
        />
      )}
    </>
  );
};

export default MeidaDisplay;

const SDiv = styled.div`
  && {
    margin: 0 5px;
  }
`;
